import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

// ------------------------
//  Aisea 用 Firebase
// ------------------------
const firebaseConfig = require(process.env.VUE_APP_GCP_ACCOUNT);
firebase.initializeApp({ ...firebaseConfig });
const db = firebase.firestore();
const storage = firebase.storage().ref();
const storageWebCam = firebase
  .storage()
  .refFromURL(String(process.env.VUE_APP_FIRESOTRAGE_WEBCAM_BUCKET_URL));
const storageDocuments = firebase
  .storage()
  .refFromURL(String(process.env.VUE_APP_FIRESOTRAGE_DOCUMENTS_BUCKET_URL));
const storagePrefixUrl = String(
  process.env.VUE_APP_FIRESOTRAGE_DOCUMENTS_PREFIX_URL
);

// ------------------------
// RadarGrid 用 Firebase
// ------------------------
const radarGridFirebaseConfig = {
  apiKey: "AIzaSyBRTAnYHmT-JJwGUirn0S3-4vmI0XKRm8o",
  authDomain: "radar-grid.firebaseapp.com",
  databaseURL: "https://radar-grid-default-rtdb.firebaseio.com",
  projectId: "radar-grid",
  storageBucket: "radar-grid.firebasestorage.app",
  messagingSenderId: "10572294331",
  appId: "1:10572294331:web:7e133a6d85bcfd2e6c619e",
  measurementId: "G-BP0PNCW3YK",
};

// すでに radarGridApp が存在しているか確認してから初期化
const radarGridApp = firebase.initializeApp(
  radarGridFirebaseConfig,
  "radarGrid"
);

// RadarGrid 用 Firestore と Storage
const radarGridStorageRef = radarGridApp.storage().ref();

export {
  db,
  firebase,
  storage,
  storageWebCam,
  firebaseConfig,
  storageDocuments,
  storagePrefixUrl,
  radarGridApp,
  radarGridStorageRef,
};
